import type { SegmentAdditionalProperties } from '@front/logic/segment'
import { isWorkerInSignup } from '@front/type/worker'

import { useWorkerTracking } from './useWorkerTracking'

const OnboardingAddInstitution = 'Worker Onboarding Add Institution '
const OnboardingSignUp = 'Worker Sign Up '

interface TrackOnboardingEventProps {
  event?: string
  suffix?: string
  additionalProperties?: SegmentAdditionalProperties
}

interface TrackingHook {
  getOnboardingTrackingText(props: TrackOnboardingEventProps): string

  onboardingTrack: (props: TrackOnboardingEventProps) => void

  isOnboardingSignup: boolean
}

export const useOnboardingTracking = (): TrackingHook => {
  const { track, user } = useWorkerTracking()
  const isOnboardingSignup = isWorkerInSignup(user)

  const getPrefix = (): string => {
    return isOnboardingSignup ? OnboardingSignUp : OnboardingAddInstitution
  }

  const getOnboardingTrackingText = ({
    suffix,
  }: TrackOnboardingEventProps): string => {
    return `${getPrefix()}${suffix}`
  }

  const onboardingTrack = ({
    event,
    suffix,
    additionalProperties,
  }: TrackOnboardingEventProps) => {
    track({
      event: event ?? getOnboardingTrackingText({ suffix }),
      additionalProperties,
    })
  }

  return { onboardingTrack, getOnboardingTrackingText, isOnboardingSignup }
}
